import { HighlightResult } from "@/utils/types/product";

interface HighlightTextProps {
  text: string;
  query: string;
  highlightResult?: HighlightResult;
  attribute?: string;
}

export const HighlightText = ({
  text,
  query,
  highlightResult,
  attribute,
}: HighlightTextProps) => {
  const baseClass = "text-body text-grey900 cursor-pointer";
  if (!query) {
    return <span className={baseClass}>{text}</span>;
  }
  const renderHighlightedText = (
    parts: { isHighlighted: boolean; value: string }[]
  ) => (
    <>
      {parts.map(({ isHighlighted, value }, idx) => (
        <span
          key={`${value}_${idx}`}
          className={baseClass}
          style={isHighlighted ? { fontWeight: "bold" } : undefined}
        >
          {value}
        </span>
      ))}
    </>
  );
  if (highlightResult && attribute) {
    const highlightedText = highlightResult?.[attribute]?.value || "";
    return renderHighlightedText(parseHighlightedText(highlightedText));
  }
  const escapeRegex = (str: string) =>
    str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const regex = new RegExp(`(${escapeRegex(query)})`, "gi");
  const parts = text.split(regex).map((part) => ({
    value: part,
    isHighlighted: part.toLowerCase() === query.toLowerCase(),
  }));

  return renderHighlightedText(parts);
};

const parseHighlightedText = (text: string) => {
  const regex = /<em>(.*?)<\/em>|([^<]+)/g; // Match highlighted text or any text outside <em> tags
  const parts = [];
  let match;

  while ((match = regex.exec(text)) !== null) {
    if (match[1] !== undefined) {
      parts.push({ value: match[1], isHighlighted: true });
    } else if (match[2] !== undefined) {
      parts.push({ value: match[2], isHighlighted: false });
    }
  }
  return parts;
};
